import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import axios from "axios";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { post, put } from "~/Services";
import { centralizedHost } from "~/Utils";
import { removeSasFromDescription } from "../Imagehelper";
import { fields } from "./constants";
import { useCentralisedFAQsDetails } from "./FAQs.hook";
export const AddEditCentralizedFaqs = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [records, setRecords] = useState<any[]>([]);

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useCentralisedFAQsDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const getRecords = () => {
    let url = `${centralizedHost}/api/get-faq-data/all-fields`;
    axios
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const HomepageFormConfig: FormConfig = {
    initialValues: {
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.published)
          : false,
      title_en: dataById ? decodeHTML(dataById.payload.title_en) : editData ? decodeHTML(editData?.title_en) : "",
      title_malay: dataById
        ? decodeHTML(dataById.payload.title_malay)
        : editData
          ? decodeHTML(editData?.title_malay)
          : "",
      title_mandarin: dataById
        ? decodeHTML(dataById.payload.title_mandarin)
        : editData
          ? decodeHTML(editData?.title_mandarin)
          : "",
      answer_en: dataById ? decodeHTML(dataById.payload.answer_en) : editData ? decodeHTML(editData?.answer_en) : "",
      answer_malay: dataById
        ? decodeHTML(dataById.payload.answer_malay)
        : editData
          ? decodeHTML(editData?.answer_malay)
          : "",
      answer_mandarian: dataById
        ? decodeHTML(dataById.payload.answer_mandarian)
        : editData
          ? decodeHTML(editData?.answer_mandarian)
          : "",
      key_info_type: dataById
        ? decodeHTML(dataById?.payload?.key_info_type)
        : editData
          ? decodeHTML(editData?.key_info_type)
          : null,
      module_name: dataById
        ? decodeHTML(dataById.payload.module_name)
        : editData
          ? decodeHTML(editData?.module_name)
          : "",

      order_sequence: dataById
        ? decodeHTML(dataById.payload.order_sequence)
        : editData
          ? decodeHTML(editData?.order_sequence)
          : "",
    },
    // fields: fields.centralizedQandAs,

    fields: fields.centralizedQandAs.map((field: any) => {
      if (field.name === "order_sequence") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;

              const selectedAirports = formValues.module_name || [];

              const existingRecord = records.find((record: any) => {
                const sameSequence = toInteger(record.order_sequence) === toInteger(value);

                const isSameRecord = record.id === (editData?.id || dataById?.payload?.id);

                const airportOverlap = record.module_name?.some((airportId: string) =>
                  selectedAirports.includes(airportId)
                );

                return sameSequence && airportOverlap && !isSameRecord;
              });

              return !existingRecord || `${field.label || field.name} already exists for selected airport`;
            },
          },
        };
      }

      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let descriptionKeys: any = ["answer_en", "answer_malay", "answer_mandarian"];
    for (const key of descriptionKeys) {
      if (data[key]) {
        data[key] = removeSasFromDescription(data[key]);
      }
    }
    const payload = {
      action: action,
      method: method,
      module: "Centralized FAQs",
      subModule: `centralizedQandAs`,
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "CENTRALIZED",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "CENTRALIZED_centralizedQandAs",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Q&A`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={HomepageFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${centralizedHost}/api/faq/${editData?.id || dataById?.payload?.id}`
              : `${centralizedHost}/api/create/faq`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Faqs"
      />
    </ContentWrapper>
  );
};
